import 'babel-polyfill';
import 'whatwg-fetch';
import './google-maps';
import './stripe';
